import { FormActions } from '@common';
import { zodResolver } from '@hookform/resolvers/zod';
import { TextareaField } from '@hypeit-gmbh/hypeit-ui';
import { Stack } from '@mantine/core';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  useUpdateVenueComps,
  useVenueCompsFormSchema,
  VenueCompsFormDataType,
} from './hooks';

const TRANS_PATH = 'VENUE_COMPS.FORM';

type VenueCompsFormPropsType = {
  venueId: string;
  overviewVersion: string;
  venueComps: string | null;
  onClose: () => void;
};

export const VenueCompsForm: React.FC<VenueCompsFormPropsType> = ({
  venueId,
  overviewVersion,
  venueComps,
  onClose,
}) => {
  const { t } = useTranslation('venueDetailsOverview');

  const { schema, defaultValues } = useVenueCompsFormSchema(venueComps);
  const { updateVenueComps } = useUpdateVenueComps({
    venueId,
    overviewVersion,
    onClose,
  });

  const methods = useForm<VenueCompsFormDataType>({
    resolver: zodResolver(schema),
    defaultValues,
  });

  const handleSubmit = async (data: VenueCompsFormDataType) => {
    await updateVenueComps(data);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        <Stack>
          <TextareaField<VenueCompsFormDataType>
            fieldName="venueComps"
            label={t(`${TRANS_PATH}.VENUE_COMPS_LABEL`)}
          />
          <FormActions
            onCancel={onClose}
            saveButtonText={t('SAVE_BUTTON', { ns: 'common' })}
            cancelButtonText={t('CANCEL_BUTTON', { ns: 'common' })}
          />
        </Stack>
      </form>
    </FormProvider>
  );
};
